import {
  HttpGetRequest,
  HttpPostRequest
} from "./HttpRequest.js";

/**
 * [HttpPostRequest description]
 * @param {[type]} route_name [description]
 * @param {[type]} body_raw   [description]
 */
export async function requestReset(payload) {
    let routeName = "/password/request";
    return await HttpPostRequest(routeName, payload).then((response) => {
      return response.json();
    });
}

/**
 * [HttpPostRequest description]
 * @param {[type]} route_name [description]
 * @param {[type]} body_raw   [description]
 */
export async function reset(data, signature, payload) {
  let routeName = "/password/reset/" + data + "/" + signature;
  return await HttpPostRequest(routeName, payload).then((response) => {
    return response.json();
  });
}

/**
 * [HttpPostRequest description]
 * @param {[type]} route_name [description]
 * @param {[type]} body_raw   [description]
 */
export async function checkValidity(data, signature) {
  let routeName = "/password/reset/" + data + "/" + signature;
  return await HttpGetRequest(routeName).then((response) => {
    return response.json();
  });
}